module.exports = __webpack_public_path__ + "static/30-bitcoin-jan2009-10e896add5fbd6e21f95aeb1f3090319.jpg";